import React from 'react';
import ReactDOM from 'react-dom';

import loadTranslations from 'js/localeSetup';
import App from './App';

(async () => {
  const rootElement = document.getElementById('giftcardContent');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<App />, rootElement);
  }
})();
